import { defineMessages } from 'react-intl';

export const messages: {
	noResultsPrimary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSecondary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSecondaryFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsClearFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsContentCleared: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSearchAllDrives: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSearchAllSites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noResultsPrimary: {
		id: 'no_results_primary',
		defaultMessage: "We couldn't find anything matching your search",
		description: 'Message shown when search request returns no results',
	},
	noResultsSecondary: {
		id: 'no_results_secondary_no_filters',
		defaultMessage: 'Try again with a different term.',
		description: 'Additional message to prompt users to try searching with a new query',
	},
	noResultsSecondaryFilters: {
		id: 'no_results_secondary_some_filters_applied',
		defaultMessage: 'Looks like you have some filters applied. You could try clearing them.',
		description: 'Additional message to prompt users to try searching without filters',
	},
	noResultsClearFilters: {
		id: 'no_results_clear_filters',
		defaultMessage: 'Clear filters',
		description: 'Button text to clear filters when no results are found',
	},
	noResultsContentCleared: {
		id: 'no_results_content_cleared_by_space_change',
		defaultMessage: 'No results - the selected folder may have been moved or deleted.',
		description:
			'Shown when no results are returned because the content filter was auto-cleared after a Drive/Site filter change',
	},
	noResultsSearchAllDrives: {
		id: 'no_results_search_all_drives',
		defaultMessage: 'Search all Drives',
		description:
			'Button to clear the content filter and search within all Google Drives when no results are found after folder auto-clear',
	},
	noResultsSearchAllSites: {
		id: 'no_results_search_all_sites',
		defaultMessage: 'Search all Sites',
		description:
			'Button to clear the content filter and search within all SharePoint Sites when no results are found after folder auto-clear',
	},
});
